// src/components/RegisterForm.js
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Form.css"; 
import { toast } from "react-toastify";

function RegisterForm() {
  const navigate = useNavigate(); 

  const [formData, setFormData] = useState({
    name: "",
    address: "",
    phone: ""
  });

  // Each element is an array of files (images/videos)
  const [imageInputs, setImageInputs] = useState([[]]);
  const [isClosed, setIsClosed] = useState(false);

  const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

  useEffect(() => {
    const deadline = new Date("2025-12-20T00:00:00"); 
    setIsClosed(new Date() > deadline);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (index, files) => {
    const updatedInputs = [...imageInputs];
    const selectedFiles = Array.from(files);

    // Validate file size
    const oversized = selectedFiles.filter(file => file.size > MAX_FILE_SIZE);
    if (oversized.length > 0) {
      alert(`❌ One or more files exceed 50MB and will not be uploaded.`);
    }

    updatedInputs[index] = selectedFiles.filter(file => file.size <= MAX_FILE_SIZE);
    setImageInputs(updatedInputs);
  };

  const removeFile = (inputIndex, fileIndex) => {
    const updatedInputs = [...imageInputs];
    updatedInputs[inputIndex].splice(fileIndex, 1);
    setImageInputs(updatedInputs);
  };

  const addImageField = () => {
    setImageInputs(prev => [...prev, []]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("address", formData.address);
    formDataToSend.append("phone", formData.phone);

    // Flatten all files and filter out null
    const allFiles = imageInputs.flat().filter(file => file);
    if (allFiles.length === 0) {
      alert("❌ Please select at least one valid file to upload.");
      return;
    }

    allFiles.forEach(file => formDataToSend.append("images", file));

    try {
      const response = await fetch("https://holidaylights.tamarac.gov/api/register", {
        method: "POST",
        body: formDataToSend
      });

      if (!response.ok) throw new Error("Upload failed");

      toast.success("🎉 Registration complete! Thank you for entering the contest.", { autoClose: 300 });
      setTimeout(() => navigate("/thank-you"), 1500);

      setFormData({ name: "", address: "", phone: "" });
      setImageInputs([[]]);
      e.target.reset();
    } catch (error) {
      console.error("Registration error:", error);
      toast.error("Oops! Something went wrong. Please try again.");
    }
  };

  return (
    <div className="form-container">
      {isClosed ? (
        <div className="register-closed">
          <h2>🎄 Contest Registration is Closed</h2>
          <p>
            Registration ended on December 10. You can now{" "}
            <Link to="/voting" style={{ color: "blue", textDecoration: "underline" }}>
              vote for your favorite house
            </Link>{" "}
            until December 25!
          </p>
          {/* Back to main page button when closed */}
          <Link to="/" className="home-btn">
            ⬅️ Back to Main Page
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="register-form">
          <h2>Enter Your Home in Tamarac’s Holiday Lights Contest</h2>
          <input name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
          <input name="address" placeholder="Address" value={formData.address} onChange={handleChange} required />
          <input name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />

          <label>Upload Images or Videos (max 50MB per file):</label>
          {imageInputs.map((files, index) => (
            <div key={index} className="file-input-group">
              <input
                type="file"
                accept="image/*,video/*"
                multiple
                onChange={e => handleImageChange(index, e.target.files)}
                required={index === 0}
              />

              <div className="file-preview">
                {files.map((file, i) => (
                  <div key={i} className="preview-item">
                    {file.type.startsWith("image") ? (
                      <img src={URL.createObjectURL(file)} alt={file.name} width={100} />
                    ) : (
                      <video src={URL.createObjectURL(file)} width={100} controls />
                    )}
                    <button type="button" onClick={() => removeFile(index, i)}>❌</button>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <button type="button" onClick={addImageField} className="add-image-btn">
            ➕ Add Another Image/Video
          </button>
          <button type="submit" className="submit-btn">Submit</button>


        </form>
      )}
                {/* Back to main page button */}
          <Link to="/" className="home-btn">
            ⬅️ Back to Main Page
          </Link>
    </div>
  );
}

export default RegisterForm;
